import React, {useEffect, useRef, useState} from 'react';
import * as S from "../styles";
import ImageContent from "#app/pages/MainPage/components/ImageContent";

const ContentBlock = ({ type, blockNum, images, className, i18n, index }) => {
    const blockRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    const BlockWrapper = type === 'odd' ? S.AnimatedBlockOdd : S.AnimatedBlockEven;
    const isImageFirst = type === 'even';

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    // Добавляем задержку для каскадной анимации
                    setTimeout(() => {
                        setIsVisible(true);
                    }, index * 100); // Каждый блок появляется с задержкой
                }
            },
            {
                threshold: 0.2,
                rootMargin: '-50px'
            }
        );

        if (blockRef.current) {
            observer.observe(blockRef.current);
        }

        return () => {
            if (blockRef.current) {
                observer.unobserve(blockRef.current);
            }
        };
    }, [index]);

    const TextContent = () => (
        <S.AnimatedBlockText
            className={isVisible ? 'visible' : ''}
            data-direction={isImageFirst ? 'right' : 'left'}
        >
            <div>
                <div className="subtitle">{i18n.mainPage[`block${blockNum}`]}</div>
                <h2>{i18n.mainPage[`block${blockNum}1`]}</h2>
                <p>{i18n.mainPage[`block${blockNum}2`]}</p>
                {i18n.mainPage[`block${blockNum}3`] && (
                    <p>{i18n.mainPage[`block${blockNum}3`]}</p>
                )}
            </div>
        </S.AnimatedBlockText>
    );

    return (
        <BlockWrapper ref={blockRef} className={isVisible ? 'visible' : ''}>
            <S.Wrap>
                {isImageFirst ? (
                    <>
                        <ImageContent isImageFirst={isImageFirst} images={images} isVisible={isVisible} blockNum={blockNum} className={className}/>
                        <TextContent />
                    </>
                ) : (
                    <>
                        <TextContent />
                        <ImageContent isImageFirst={isImageFirst} images={images} isVisible={isVisible} blockNum={blockNum} className={className}/>
                    </>
                )}
            </S.Wrap>
        </BlockWrapper>
    );
};

export default ContentBlock;